import {Routes} from '@angular/router';
import {IndexComponent as PublicationIndexComponent} from './index/index.component';
import {EditComponent as PublicationEditComponent} from './edit/edit.component';
import {PublicationService} from '../../../services/api/administration/publication.service';
import {canActivateGuard} from '../../../guards/can-activate-guard';
import {PERMISSION} from '@generated-backend-types';

export const routes: Routes = [
  {
    path: '',
    component: PublicationIndexComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_PUBLICATION_READ_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.publications.index.breadcrumb',
          translate: true,
          route: '/administration/publications'
        },
      ]
    }
  },
  {
    path: 'add',
    component: PublicationEditComponent,
    canActivate: [canActivateGuard],
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_PUBLICATION_CREATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.publications.index.breadcrumb',
          translate: true,
          route: '/administration/publications'
        },
        {label: 'authenticated.administration.publications.create.breadcrumb', translate: true,},
      ]
    }
  },
  {
    path: ':id',
    component: PublicationEditComponent,
    canActivate: [canActivateGuard],
    resolve: {
      publication: PublicationService,
    },
    data: {
      allPermissionsNeeded: [PERMISSION.ADMINISTRATION_PUBLICATION_UPDATE_ALL],
      breadcrumb: [
        {
          label: 'authenticated.administration.publications.index.breadcrumb',
          translate: true,
          route: '/administration/publications'
        },
        {dynamic: true, dataKey: 'publication.title', route: '/administration/publications/:id'},
        {label: 'authenticated.administration.publications.edit.breadcrumb', translate: true,},
      ]
    }
  }
];
